// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regulatory notices. Deliberately quiet but never hidden: these must remain
   legible and must not be collapsible, so no display:none at any breakpoint. */

.compliance-notice {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(120, 130, 150, 0.1);
  border: 1px solid rgba(120, 130, 150, 0.18);
  color: #5a6270;
  font-size: 0.75rem;
  line-height: 1.35;
}

.compliance-notice--compact {
  padding: 5px 9px;
  font-size: 0.68rem;
  gap: 6px;
}

.compliance-notice__icon {
  flex: 0 0 auto;
  font-size: 1.05rem;
  margin-top: 1px;
  opacity: 0.75;
}

.compliance-notice__text {
  flex: 1 1 auto;
}

@media (prefers-color-scheme: dark) {
  .compliance-notice {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
    color: #b6bdca;
  }
}

/* Compact (i) control — reveals the notice text on demand */
.compliance-notice-info {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.compliance-notice-info__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid rgba(248, 250, 252, 0.28);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.35);
  color: rgba(248, 250, 252, 0.78);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}

.compliance-notice-info__btn:hover,
.compliance-notice-info__btn:focus-visible {
  color: #f8fafc;
  border-color: rgba(248, 250, 252, 0.55);
  outline: none;
}

.compliance-notice-info__tip {
  position: absolute;
  z-index: 8;
  top: calc(100% + 6px);
  right: 0;
  width: min(220px, 70vw);
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(15, 23, 42, 0.96);
  color: #e2e8f0;
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/compliance/ComplianceNotice.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,cAAc;EAChB;AACF;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;AACtB","sourcesContent":["/* Regulatory notices. Deliberately quiet but never hidden: these must remain\n   legible and must not be collapsible, so no display:none at any breakpoint. */\n\n.compliance-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: rgba(120, 130, 150, 0.1);\n  border: 1px solid rgba(120, 130, 150, 0.18);\n  color: #5a6270;\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.compliance-notice--compact {\n  padding: 5px 9px;\n  font-size: 0.68rem;\n  gap: 6px;\n}\n\n.compliance-notice__icon {\n  flex: 0 0 auto;\n  font-size: 1.05rem;\n  margin-top: 1px;\n  opacity: 0.75;\n}\n\n.compliance-notice__text {\n  flex: 1 1 auto;\n}\n\n@media (prefers-color-scheme: dark) {\n  .compliance-notice {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.12);\n    color: #b6bdca;\n  }\n}\n\n/* Compact (i) control — reveals the notice text on demand */\n.compliance-notice-info {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.compliance-notice-info__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 1px solid rgba(248, 250, 252, 0.28);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(248, 250, 252, 0.78);\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.compliance-notice-info__btn:hover,\n.compliance-notice-info__btn:focus-visible {\n  color: #f8fafc;\n  border-color: rgba(248, 250, 252, 0.55);\n  outline: none;\n}\n\n.compliance-notice-info__tip {\n  position: absolute;\n  z-index: 8;\n  top: calc(100% + 6px);\n  right: 0;\n  width: min(220px, 70vw);\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(15, 23, 42, 0.96);\n  color: #e2e8f0;\n  font-size: 0.68rem;\n  font-weight: 500;\n  line-height: 1.35;\n  text-align: left;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
